/** Skill 内容的文件下载工具 */
import JSZip from 'jszip';
function triggerDownload(filename, blob) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
export function downloadMd(filename, content) {
    triggerDownload(filename, new Blob([content], { type: 'text/markdown;charset=utf-8' }));
}
/** Skill 规范固定要求 zip 内的入口文件名 */
const SKILL_ENTRY_FILENAME = 'SKILL.md';
/**
 * 按官方 Agent Skills 规范把 markdown 打包成 zip：
 *   - zip 顶层只有一个目录，名字就是 `folderName`，必须与 SKILL.md frontmatter 的 `name` 一致；
 *   - 目录下放唯一入口文件 `SKILL.md`，内容即传入的 markdown 文本。
 * 调用方负责保证 `folderName` 合规（小写字母 / 数字 / 连字符，≤ 64 字符）。
 */
export async function downloadZip(folderName, content) {
    const zip = new JSZip();
    zip.folder(folderName).file(SKILL_ENTRY_FILENAME, content);
    const blob = await zip.generateAsync({ type: 'blob' });
    triggerDownload(`${folderName}.zip`, blob);
}
/**
 * 与 downloadZip 同结构（顶层目录 + SKILL.md），但产出 base64 字符串
 * 用于发布到 knot 时的 file_data 字段（需要 base64 编码的 zip 文件内容）。
 */
export async function buildSkillZipBase64(folderName, content) {
    const zip = new JSZip();
    zip.folder(folderName).file(SKILL_ENTRY_FILENAME, content);
    return await zip.generateAsync({ type: 'base64' });
}
